
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.552 15.39c-2.834-1.75-2.682-7.437-2.68-7.522a5.908 5.908 0 00-4.18-5.641v-.51A1.72 1.72 0 008.974 0a1.72 1.72 0 00-1.718 1.718v.509a5.92 5.92 0 00-4.18 5.67c.054 1.59-.32 6.036-2.68 7.492a.833.833 0 00.437 1.543h4.99a3.239 3.239 0 003.151 2.512 3.24 3.24 0 003.152-2.512h4.988a.833.833 0 00.438-1.543m-9.326-.124H2.881c1.99-2.809 1.868-7.197 1.861-7.397a4.237 4.237 0 014.233-4.232c2.333 0 4.231 1.898 4.232 4.203-.008.225-.13 4.617 1.86 7.426h-6.84","fill":"#595959","fill-rule":"evenodd"}})])
          )
        }
      }
    